import { createApp } from 'vue';
import eventBus from '@tools/event-bus';
import translation from '@elements/translation';

/**
 * Init MultiOffice configurator launcher
 */
export default function (el) {
  const component = {
    template: '<div></div>',
    delimiters: [ '${', '}' ],
    mixins: [ translation ],
    data() {
      return {
        capacity: 0,
        surface: 0,
        price: 0,
        offerTypes: [],
      };
    },
    mounted() {
      eventBus.addEventListener('multioffice-change-configuration', this.updateConfiguration);

      const combinators = document.querySelectorAll('[data-open-combinator]');
      if (combinators) {
        combinators.forEach((element) => {
          element.addEventListener('click', () => {
            this.showMultiOffice();
          });
        });
      }

      const combinatorSelectors = [
        '.navbar-infos__primary span[data-type-combinator]',
        '.mobile-contact-content__details span[data-type-combinator]',
      ];
      combinatorSelectors.forEach((selector) => {
        const navbarTypeCombinator = document.querySelector(selector);
        navbarTypeCombinator.addEventListener('click', () => {
          if (navbarTypeCombinator.classList.contains('multiple')) {
            this.showMultiOffice();
          }
        });
      });
    },
    methods: {
      showMultiOffice() {
        eventBus.dispatchEvent(new Event('multioffice-show-slidein'));
      },
      /**
       * Receive new multi offices configuration from configurator
       * @param {Object} newConfiguration
       */
      updateConfiguration(newConfiguration) {
        this.capacity = newConfiguration.detail.capacity;
        this.surface = newConfiguration.detail.surface;
        this.price = newConfiguration.detail.price;
        this.offerTypes = newConfiguration.detail.offerTypes;
      },
    },
  };

  return createApp(component).mount(el);
}
